import { cn } from '@ctct/summit-core';
import { Command as CommandPrimitive } from 'cmdk';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

/**
 * Individual items in a CommandList or CommandGroup
 */
const CommandItem = forwardRef<
  ElementRef<typeof CommandPrimitive.Item>,
  ComponentPropsWithoutRef<typeof CommandPrimitive.Item>
>(({ className, ...props }, ref) => (
  <CommandPrimitive.Item
    ref={ref}
    className={cn(
      'rds-command-item',
      `
        r:relative r:flex r:items-center r:p-2.5 r:cursor-pointer r:select-none
        r:rounded-xs r:text-base r:outline-hidden
        r:aria-selected:bg-(--item-bg-selected)
        r:aria-selected:text-(--item-text-selected)
        r:data-[disabled='true']:pointer-events-none
        r:data-[disabled='true']:opacity-50
      `,
      className
    )}
    data-sds-id="command-item"
    {...props}
  />
));

CommandItem.displayName = 'CommandItem';

export { CommandItem };
